import type { ConditionMarkerMeaning, StatusColor } from '@repo/types';
import type { IconName } from '@repo/ui';
import { capitalize } from 'helpers';
import { ConditionEvaluationMeaning } from 'types/Conditions';

/**
 * "Microbiome Signature Detected" -> "Signature detected". Anchored because "Next
 * Check at 12 months" is also an evaluation and has no prefix to lose, and note
 * `capitalize` flattens everything past the first letter, proper nouns included.
 */
export const conditionEvaluationLabel = (evaluation: string) =>
  capitalize(evaluation.replace(/^Microbiome\s+/, ''));

/** `null` for neutral, which the design leaves unmarked. */
export const conditionEvaluationIcon = (
  meaning: ConditionMarkerMeaning,
): IconName | null => {
  switch (meaning) {
    case ConditionEvaluationMeaning.FLAG:
      return 'alertTriangleFilled';
    case ConditionEvaluationMeaning.BORDERLINE:
      return 'alertCircleFilled';
    case ConditionEvaluationMeaning.CLEAR:
      return 'checkFilled';
    default:
      return null;
  }
};

/**
 * Pill tint for an evaluation. Neutral ("Next check at…", "Beyond biomarker age
 * range") stays gray: neither is a result either way.
 */
export const conditionEvaluationColor = (
  meaning: ConditionMarkerMeaning,
): StatusColor => {
  switch (meaning) {
    case ConditionEvaluationMeaning.FLAG:
      return 'red';
    case ConditionEvaluationMeaning.BORDERLINE:
      return 'orange';
    case ConditionEvaluationMeaning.CLEAR:
      return 'green';
    default:
      return 'grey';
  }
};
